import axios, { getAuthHeader } from './client.ts';
import services from './services.ts';

export const ENDPOINTS = {
  DASHBOARD: (userId: string, timezone: string) => `${services.DASHBOARD}/dashboard/${userId}?timezone=${timezone}`,
};

export const getDashboard = (token: string, userId: string, timezone: string) =>
  axios.get(ENDPOINTS.DASHBOARD(userId, timezone), {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });
